(function (upp) {
    'use strict';

    var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE;
    upp.service('pickAtStoreOptionsService', ['appi', '$q',
        function (appi, $q) {
            var cachedPickAtSoreOptions;

            /**
             * Returns a list of options for pick at store
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             */
            var getPickAtStoreOptions = function() {
                if (cachedPickAtSoreOptions) {
                    return $q.when(cachedPickAtSoreOptions)
                }

                return appi.http.get(URL_API_REST_SERVER + 'v2/pick-at-store-options')
                    .then(function (response) {
                        var result = {
                            pickAtStoreOptions: response.data['pickAtStoreOptions'],
                        };
                        cachedPickAtSoreOptions = angular.copy(result);
                        return result
                    })
            };

            return {
                get: getPickAtStoreOptions
            };
        }]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/cart/services/pickAtStoreOptions-services.js